export enum ViewContext {
  ResourceGrid = 'resources',
  ProjectGrid = 'projects'
}

export type ViewContextKey = keyof typeof ViewContext;
